import { addPvNew } from '../../../utils';
import { isScreenOptimization } from '../abtestConfig';
export default {
  name: 'PoiCard',
  props: {
    poiList: {
      type: Array,
      default() {
        return [];
      }
    },
    poiLink: {
      type: String,
      default() {
        return '';
      }
    },
    unique_id: {
      type: String,
      default() {
        return '';
      }
    },
    source: {
      type: String,
      default() {
        return '';
      }
    },
    abtest: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isScreenOptimization
    };
  },
  computed: {
    poiNum() {
      return this.poiList.length;
    },
    poiBg() {
      return this.poiList[1] && this.poiList[1].image;
    }
  },
  methods: {
    jumpCityWalk() {
      addPvNew(['NewMedia.detailspage.poidrawerpoi.click'], {
        type: 'image',
        note_style: 'Micro',
        poi_action: 'poi',
        unique_id: this.unique_id,
        source: this.source
      });
      window.location.href = this.poiLink;
    }
  }
};